import { useQuery } from "@tanstack/react-query";
import { fetchStandardStatements } from "../api/fetchStandardStatements";

export const useStandardStatements = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["standardStatements"],
    queryFn: fetchStandardStatements,
  });

  return { data: data?.result || [], error, isLoading, refetch };
};

